module.exports = __webpack_public_path__ + "img/GBP.adad8418.png";